import { type ReactNode } from "react";
import { createContext, useContext, useState } from "react";
import { type User, signOut } from "firebase/auth";
import {
  auth,
  createMagicLink,
  createUser,
  loginUser,
  processMagicLink,
  sendSMSCode,
  signInWithSMSCode,
} from "src/api/firebase";
import type { AuthContextProps } from "src/types/auth";

export const AuthContext = createContext<AuthContextProps | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(auth.currentUser);

  const logout = async () => {
    setUser(null);
    await signOut(auth);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        createUser,
        createMagicLink,
        loginUser,
        logout,
        processMagicLink,
        sendSMSCode,
        signInWithSMSCode,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
